import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M7 3a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zm8 0a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM6 7a1 1 0 0 0-1 1v2a2 2 0 0 0-2 2v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6h2v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-8a2 2 0 0 0-2-2V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2h-2V8a1 1 0 0 0-1-1z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }